import React from 'react';
import { Link } from 'react-router-dom';

const LoadMoney = () => (
  <main style={{ maxWidth: 600, margin: '4rem auto', padding: '2rem' }}>
    <h1>Account top-ups are currently unavailable</h1>
    <p>No funds have been charged or added. Online balance top-ups are not available yet.</p>
    <p>Subscription and phone-number checkout does not add money to an existing account balance.</p>
    <Link to="/dashboard">Return to Dashboard</Link>
  </main>
);

export default LoadMoney;
